import styled from '@emotion/styled';

import { screenMedium } from '@app/styles/theme/breakpoints';
import { rem } from '@app/styles/theme/layout';

import { UnstyledButton } from '../Button';

interface HamburgerMenuProps {
  toggle: (isOpen: boolean) => void;
  isOpen: boolean;
}

const Menu = styled(UnstyledButton)`
  display: none;
  cursor: pointer;
  position: relative;
  outline: none;
  width: ${rem(20)};
  height: ${rem(20)};

  @media screen and (max-width: ${screenMedium}) {
    display: block;
  }
`;

const Lines = styled.span`
  &::after {
    content: '';
    top: ${rem(-10)};
  }

  &::before {
    content: '';
    top: ${rem(-15)};
  }

  &,
  &::after,
  &::before {
    position: absolute;
    display: block;
    transition: all 300ms ease-out;
    transform: rotate(0deg);
    border-radius: ${rem(5)};
    margin: 5px 0;
    background: #fff;
    width: ${rem(20)};
    height: ${rem(2)};
  }

  ${(props: Pick<HamburgerMenuProps, 'isOpen'>) =>
    props.isOpen &&
    `
    & {
      background: transparent;
    }

    &::before {
      transform: rotate(-45deg);
      top: ${rem(-10)};
    }

    &::after {
      top: ${rem(-10)};
      transform: rotate(45deg);
    }
  `}
`;

const HamburgerMenu = ({ toggle, isOpen }: HamburgerMenuProps) => (
  <Menu onClick={() => toggle(!isOpen)}>
    <Lines isOpen={isOpen} />
  </Menu>
);

export default HamburgerMenu;
